// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1hb09","visuallyhidden":"_30S5m","hide-text":"_3-0kA","center":"UZAF6","noprint":"l7LtY","root":"_2rmUE","caption":"d2l1j","fullcaption":"CTL_e","captionButton":"jg2NW","image":"_3mT80"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-image/styles/feature.scss
 ** module id = 133
 ** module chunks = 2
 **/